import { CareTicket } from '../../../../myt_chat/src/chat/packets/CareTicket';
export const toMs = (t: any): number => {
  if (t == null) return 0;

  if (typeof t === 'number') {
    if (!isFinite(t)) return 0;
    if (t > 1e18) return Math.floor(t / 1_000_000); // ns → ms
    if (t > 1e15) return Math.floor(t / 1_000); // µs → ms
    if (t < 1e12) return t * 1000; // sec → ms
    return t; // ms
  }

  if (typeof t === 'string') {
    if (/^\d+$/.test(t)) return toMs(Number(t));
    const d = Date.parse(t);
    return isNaN(d) ? 0 : d;
  }

  if (typeof t === 'bigint') {
    const max = BigInt(Number.MAX_SAFE_INTEGER);
    return Number(t > max ? t / BigInt(1_000_000) : t); // ns → ms if too big
  }

  return 0;
};

// CHANGE: single comparator used everywhere (unread first → newest timestamp → name)
export const compareTickets = (a: CareTicket, b: CareTicket) => {
  const au = a.unread > 0;
  const bu = b.unread > 0;
  if (au !== bu) return bu ? 1 : -1; // unread at the top

  const at = toMs(a.message?.timestamp);
  const bt = toMs(b.message?.timestamp);
  if (bt !== at) return bt - at; // newest first

  return (a.name || '').localeCompare(b.name || '');
};
